import React from 'react'
import { useState , useEffect } from 'react';
import FormInputs from '../../../../components/UI/FormInputs';
import SectionLoader from '../../../../components/UI/SectionLoader';
import TableGrid from '../../../../components/UI/TableGrid';
import { isObject, isSet,USDateTimeString } from '../../../../utils/commonUtils';
import VisitsService from '../../../../services/VisitsService';
import EmrVisitsService from '../../../../services/EmrVisitsService';
import LookupService from '../../../../services/LookupService';
import { DOCUMENT_TYPE } from '../../../../utils/constant';
const ImagesTab = (props) => {
      const visit_id=props.visit_id
      const employee_id=props.employeeId
      const [uploadedFile,setUploadedFile] = useState(null);
      const [isLoading,setLoaded] = useState(false);
      const [documentsList, setDocumentsList] = useState({ tableHeaders: [], tableRows: { data: [] } });
      const [documentFormData,setDocumentFormData]=useState({})
      const [lookupData,setLookupData]=useState({});
      const [validation,setValidation]=useState({});
      const [searchTerm, setSearchTerm] = useState('');
      const [activeSearchTerm, setActiveSearchTerm] = useState('');
      const [pagination, setPagination] = useState({
        sort_by: 'updated_at',
        sort_order: 'desc'
      });
 
      useEffect(() => {
        fetchDocumentList();
        fetchLookupsData();
      }, []);
      const fetchDocumentList = async (search = activeSearchTerm, sortBy = pagination.sort_by, sortOrder = pagination.sort_order) => {
          try {
              let documents=await EmrVisitsService.getEmrDocuments(visit_id, search, sortBy, sortOrder);
              console.log('fetchDocumentList ::',documents);
              let tableData=[];
              tableData = await documents.map((item) => ({
                  rowId: item.id,
                  data: {
                      name: item.file,
                    document_type:item.document_type,
                      updatedAt:  USDateTimeString(item.updated_at) ,
                      action: [{
                          className: 'btn btn-icon btn-transparent-dark',
                          iconType: 'Remove',
                          acl: 'any',
                          title: 'Delete',
                          isDelete:true,
                          clickHandler: () => deleteHandler(item.id),
                      }]
                  }
              }));
              setDocumentsList({ tableHeaders: getTableHeaders(), tableRows: { data: tableData } });
  
          } catch (error) {
              console.error("Error fetching additional documents:", error);
          }
      }
          const fetchLookupsData = async () => {
              try {
                  const [documentTypeData] = await Promise.all([
                      LookupService.getLookupByKey(DOCUMENT_TYPE),
                  ]);
                  let documenTypeOptions = [{ label: '-None-', value: '' }];
                  documentTypeData.forEach((item) => {
                      documenTypeOptions.push({
                          label: item.value,
                          value: item.value
                      });
                  });
                  console.log('document_type_data',documenTypeOptions);
                  setLookupData({...lookupData,['document_type']:documenTypeOptions});
              } catch (e) {
     
              }
          }
      const getTableHeaders = () => [
          { label: 'File Name', key: 'name', type:'FileType', sortName: 'file_name' },
          { label: 'Type', key: 'document_type', type: 'SelectList', sortName: 'document_type' },
          { label: 'Updated Date', key: 'updatedAt', type: '', sortName: 'updated_at' },
          { label: 'Action', key: 'action', type: 'Actions' },
          // Add more columns as needed
      ];
 
     const submiHandler = async () => {
         try {
            setValidation({});
            if (!uploadedFile) {
                  props.Toast.error("Select File to proceed further");
                  return; 
              }
            if (!documentFormData.document_type || documentFormData.document_type.trim() === '') {
                setValidation({ document_type: "Document Type is required." });
                  return; 
              }
              setLoaded(true);
              const formData = new FormData();
              formData.append('file', uploadedFile);
              formData.append('document_type',documentFormData.document_type);
              formData.append('employee_id',employee_id)
              const response = await EmrVisitsService.addEmrDocuments(visit_id, formData);
              
              let updateValidation={}; // Start with a fresh object for backend errors

              if (response.status && response.status == "ERROR") {
                              if (isObject(response.data)) {
                                for (let key in response.data) {
                                  updateValidation = {
                                    ...updateValidation,
                                    [key]: response.data[key].join(","),
                                  };
                                }
                              } else {
                                props.Toast.error(response.data);
                              }
                              if (Object.keys(updateValidation).length > 0) {
                                setValidation(updateValidation);
                                setLoaded(false); 
                                return;
                              }
              }
              props.Toast.success("Document Added Successfully");
              setUploadedFile(null);
              fetchDocumentList();
              setDocumentFormData({});
              setLoaded(false);
        } catch (error) {
              console.error("Error submitting document:", error);
              setLoaded(false);
          }
      }
    const inputFields = [
        {
            type: 'SelectList',
            options:lookupData.document_type ||[],
            label: 'Document Type',
            className: 'form-control form-control-solid',
            name: 'document_type',
            required:true
        },
    ];
 
 
      const deleteHandler = async (AttachmentId) => {  
              setLoaded(true);
              try {
                  //delete logic goes here
                  let response = await EmrVisitsService.deleteEmrDocuments(visit_id,AttachmentId);
                  props.Toast.success('Document Deleted successfully');
                  setLoaded(false);
                  fetchDocumentList();
              } catch (error) {
                  setLoaded(false);
                  console.error("Error deleting document:", error);
              }
      }
  
      const changeHandler=(val,fieldName)=>{
      setDocumentFormData(prevState => ({
                ...prevState.labformData, [fieldName]: val }
          ));
      }

      const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
      };

      const handleSearch = () => {
        setActiveSearchTerm(searchTerm);
        fetchDocumentList(searchTerm);
      };

      const handleClear = () => {
        setSearchTerm('');
        setActiveSearchTerm('');
        setPagination({
          sort_by: 'updated_at',
          sort_order: 'desc'
        });
        fetchDocumentList('', 'updated_at', 'desc');
      };

      const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
          handleSearch();
        }
      };

      const fetchTableRecords = (newPagination) => {
        setPagination(newPagination);
        fetchDocumentList(activeSearchTerm, newPagination.sort_by, newPagination.sort_order);
      };
  
  return (
    <>
    <div className="sh_cardBody" >
    <div className="sh_innerPortview">
        <div className="row m-2">
            <div className="col-12 col-lg-4 p-1">
              <div className="sh_cardBox shadow-none border mb-0" style={{ height: "380px" }}>
                <div className="sh_cardBody p-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="f-500 text-md text-truncate mb-0">
                          {"Images"}
                        </label>
                        <FormInputs
                          type="FileUpload"
                          title="Field Document"
                          className=""
                          value={uploadedFile||""}
                          changeHandler={(val) => setUploadedFile(val)}
                        />
                      </div>
                    </div>
                    {inputFields.map((item, index) => (
                      <div className="col-12" key={index}>
                        <div className="form-group">
                          <label className="f-500 text-md text-truncate mb-0">
                            {item.label}
                          </label>
                          <FormInputs
                            {...item}
                            value={isSet(documentFormData[item.name], "")}
                            
                            changeHandler={(val) => changeHandler(val, item.name)}
                          />
                            {isSet(validation[item.name], "") !== "" ? (<span className="text-danger m-1"> {validation[item.name]}</span>)
                             :
                              ""
                             }
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="sh_cardFooter justify-content-center">
                  <button
                    className="btn btn-primary btn-sm text-sm"
                    onClick={submiHandler}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-8 p-1">
              <div className="sh_cardBox h-auto shadow-none border mb-0" >
                <div className="sh_cardHeader">
                  <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                    <h6 className="text-md mb-0">Upload Physical Attachment</h6>
                  </div>
                </div>
                <div className="sh_cardBody p-0">
                  {/* Search Input and Buttons */}
                  <div className="p-3 border-bottom">
                    <div className="d-flex justify-content-end sh_filter_formheader">
                      {/* Search Input */}
                      <div className="d-flex p-1">
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </div>
                      {/* Action Buttons */}
                      <div className="d-flex">
                        <div className="addAction mr-2">
                          <div className="btn-group p-1">
                            <button
                              className="btn btn-primary"
                              onClick={handleSearch}
                            >
                              Search
                            </button>
                            <button
                              className="btn btn-outline-secondary"
                              style={{ backgroundColor: 'white' }}
                              onClick={handleClear}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <SectionLoader isLoading={isLoading} />
                  {documentsList.tableRows.data.length > 0 ? (
                    <TableGrid 
                      {...documentsList} 
                      pagination={pagination}
                      fetchTableRecords={fetchTableRecords}
                    />
                  ) : (
                    <div className="p-3 text-center text-muted">
                      {activeSearchTerm ? 'No documents found matching your search.' : 'No documents uploaded yet.'}
                    </div>
                  )}
                </div>
              </div>
            </div>
        </div>
         
      </div>
    </div>
</>
  )
}

export default ImagesTab
